import { Loader } from 'components/Loader/Loader';
import { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { CalendarFetchByDay } from '../../../../components/OrderListTable/CalendarFetch/CalendarFetchByDay';
import { useGetDailyLineHaulSummary } from '../../../../hooks/useGetDailyPickupsSummary';
import { useGetPerformanceScanList } from '../../../../hooks/useGetPerformanceScanList';
import { Region } from '../../../../types/orderTypes';
import { CelebrateLeader } from '../CelebrateLeader/CelebrateLeader';
import { LinehaulInfoProgressBars } from '../LinehaulInfoProgressBars/LinehaulInfoProgressBars';
import { LineHaulInfoTable } from '../LineHaulInfoTable/LineHaulInfoTable';
import { ScanMenuButtons } from '../ScanMenuButtons/ScanMenuButtons';
import { ScanPerformanceListComponent } from '../ScanPerformanceListComponent/ScanPerformanceListComponent';
import './ScanPerformanceListWithLineHaul.scss';
import { ScansTotalRemaining } from '../ScansTotalRemaining/ScansTotalRemaining';
import { showDayByHourOfDay } from '../showDayByHourOfDay';
import { ParcelsLineHaulCount } from '../../../../types/statsTypes';

export function ScanPerformanceListWithLineHaul({
  region,
}: {
  region: Region;
}): JSX.Element {
  const dayToSHow: Dayjs = showDayByHourOfDay();
  const [startDate, setStartDate] = useState(dayToSHow);

  const { performanceScanList, isLoading } = useGetPerformanceScanList(
    startDate,
    startDate
  );

  const fetchValues = (givenDate: Dayjs) => {
    setStartDate(givenDate);
  };

  return (
    <div className="scanResultsLayout">
      <ScanMenuButtons />

      <CalendarFetchByDay
        fetchValues={fetchValues}
        givenDate={startDate}
        trackingName={'Monitor-scan'}
      />
      {isLoading === true && (
        <div className={'loading'}>
          <Loader type="spinner" size="large" />
        </div>
      )}
      {isLoading === false && (
        <>
          <div className="grid-container">
            <div className="highscore">
              <ScanPerformanceListComponent
                performanceScanList={performanceScanList}
                isLeaderBoard={false}
              />
            </div>
            <div className="info"></div>

            <div className="celebrateLeader">
              <CelebrateLeader performanceScanList={performanceScanList} />
            </div>
            <LineHaulDataComponents forDate={startDate} />
          </div>
        </>
      )}
    </div>
  );
}

export function LineHaulDataComponents({
  forDate,
}: {
  forDate: Dayjs;
}): JSX.Element {
  const { parcelsLineHaulSummary, lineHaulSummaryLoading } =
    useGetDailyLineHaulSummary(forDate);

  if (lineHaulSummaryLoading === true) {
    return <> </>;
  } else if (lineHaulSummaryLoading === false) {
    return (
      <>
        <div className="Scans-total-Remaining">
          <ScansTotalRemaining
            parcelsLineHaulSummary={parcelsLineHaulSummary}
          />
        </div>

        <LinehaulInfo parcelsLineHaulSummary={parcelsLineHaulSummary} />
      </>
    );
  }
}

export function LinehaulInfo({
  parcelsLineHaulSummary,
}: {
  parcelsLineHaulSummary: ParcelsLineHaulCount[];
}): JSX.Element {
  return (
    <div className="Linehaul-info">
      <LinehaulInfoProgressBars
        parcelsLineHaulSummary={parcelsLineHaulSummary}
      />
      <LineHaulInfoTable parcelsLineHaulSummary={parcelsLineHaulSummary} />
    </div>
  );
}
